import { Component } from 'preact';
import { findFilterArray } from '%/utils/filters';
import PropTypes from 'prop-types';
import ResultSearch from './ResultSearchSimple';
import { clearFilters } from '../../stores/SearchFilter';

class ResultSearchSimpleApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showResults: false,
      keyword: '',
      total: 0,
      selectedCategories: '',
      enableClearButton: false,
    };

    this.watch();
  }

  handleClearFilters() {
    clearFilters();
  }

  watch() {
    window.store.SearchFilter.watch(state => {
      this.setState({
        showResults: state.showResults,
        keyword: state.lastKeyword,
        total: state.total,
        selectedCategories: findFilterArray(
          state.filterArray,
          'q[model_category_in][]',
        ),
        enableClearButton:
          !!state.lastKeyword.length || !!state.filterArray.length,
      });
    });
  }

  render() {
    const {
      showResults,
      keyword,
      total,
      selectedCategories,
      enableClearButton,
    } = this.state;

    const { showClearButton, displayInfo } = this.props;

    if (!showResults) return null;

    return (
      <ResultSearch
        keyword={keyword}
        total={total}
        selectedCategories={selectedCategories}
        showClearButton={showClearButton && enableClearButton}
        handleClearFilters={this.handleClearFilters}
        displayInfo={displayInfo}
      />
    );
  }
}

ResultSearchSimpleApp.propTypes = {
  showClearButton: PropTypes.bool,
  displayInfo: PropTypes.string,
};

ResultSearchSimpleApp.defaultProps = {
  displayInfo: 'keyword',
  showClearButton: false,
};

export default ResultSearchSimpleApp;
